import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyBhJMCC4HYDYnRVG6vsT4CWqD0VL2qujyc",
    authDomain: "sporttikirja.firebaseapp.com",
    databaseURL: "https://sporttikirja.firebaseio.com",
    projectId: "sporttikirja",
    storageBucket: "sporttikirja.appspot.com",
    messagingSenderId: "649416324190",
    appId: "1:649416324190:web:e25cf8873db6c03e"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();

export default firebase;